const emptyDoc = {
  newFormatEffect: true, //esta prop sirve para mostar un formulario actualizado, los que no tengan esta prop usaran otro formulario en FormObjetos
};
const emptyObject = {
  list: [
    {
      arrId: uuidv4(),
      doc: { ...emptyDoc },
      type: "empty",
    },
  ],
  emptyDoc: { ...emptyDoc },
};
const state = () => ({
  ...emptyObject,
});

// actions
const actions = {
  async setRobado({ commit }, params) {
    let empty = params.type === "empty";
    if (params.doc.tipoEfecto?.nombre) {
      if (params.type === "empty" && !params.doc.tipoEfecto) {
        await commit("setRobado", params);
        commit("addRobado");
        return;
      }
    }

    const camposPermitidos = ["tipoEfecto", "newFormatEffect"];
    const camposParams = Object.keys(params.doc);
    const camposAdicionales = camposParams.filter((campo) => !camposPermitidos.includes(campo));
    const camposFaltantes = camposPermitidos.filter((campo) => !camposParams.includes(campo));

    if (camposFaltantes.length > 0) {
      // console.error("No se realizó el commit. Faltan los campos obligatorios:", camposFaltantes);
      return;
    }

    if (camposAdicionales.length > 0) {
      // console.warn("Campos adicionales detectados:", camposAdicionales);
      if (camposAdicionales.length === 1 && camposAdicionales[0] === "arrId") {
        return;
      } else {
        await commit("setRobado", params);
        if (empty) commit("addRobado");
      }
    }
  },
  async deleteRobadoByArrId({ commit, getters }, arrId) {
    let index = await getters.getIndexRobadoByArrId(arrId);
    commit("deleteRobado", index);
  },
};

const getters = {
  robadosTodos: (state) => {
    return state.list;
  },
  robadosTodosSelect: (state, getters, rootState) => {
    let formType = rootState.sumario.formType;
    return state.list.map((item) => {
      if (item.type == "empty") {
        return {
          arrId: item.arrId,
          type: item.type,
          name: "Nuevo efecto",
          doc: {
            newFormatEffect: true,
            tipoEfecto: null,
          },
        };
      }
      let name = rootState?.siis?.subcategoriasDeposito?.filter(
        (elemento) => elemento.SubcategoriaID === item.doc.SubcategoriaID
      )?.[0]?.Nombre;
      name = item?.doc?.tipo !== undefined ? item?.doc?.tipo : name;
      if (name === undefined) {
        return {
          arrId: item.arrId,
          type: item.type,
          name: "Datos Incompletos",
          tipoEfecto: item.doc.tipoEfecto,
          newFormatEffect: item.doc.newFormatEffect,
          EfectoDepositoID: item.doc.EfectoDepositoID,
        };
      }
      return {
        arrId: item.arrId,
        type: item.type,
        name: name,
        tipoEfecto: item.doc.tipoEfecto,
        newFormatEffect: item.doc.newFormatEffect,
        EfectoDepositoID: item.doc.EfectoDepositoID,
      };
    });
  },

  robadosTodosResumen: (state, getters) => {
    return getters.robadosTodosSelect.filter((todo) => todo.type === "doc");
  },
  robadosList: (state, getters) => {
    return getters.robadosTodos.filter((todo) => todo.type === "doc");
  },
  robadosCount: (state, getters) => {
    return getters.robadosTodos.length - 1;
  },
  getNewRobadoArrId: (state) => {
    return state.list[state.list.length - 1].arrId;
  },
  getRobadoByArrId: (state) => (arrId) => {
    return state.list.find((todo) => todo.arrId === arrId);
  },
  getIndexRobadoByArrId: (state) => (arrId) => {
    return state.list.findIndex((todo) => todo.arrId === arrId);
  },
};

// mutations
const mutations = {
  setRobado(state, params) {
    state.list = state.list.map((n) => {
      if (n.arrId === params.arrId) {
        params.doc.arrId = params.arrId;
        if (params.doc.newFormatEffect === undefined) {
          params.doc.newFormatEffect = true;
        }
        params.type = "doc";
        return params;
      }
      return n;
    });
  },
  addRobado(state) {
    state.list = [
      ...state.list,
      {
        arrId: uuidv4(),
        doc: {
          ...state.emptyDoc,
          tipoEfecto: null,
        },
        type: "empty",
        // conocido: true,
        // hasIdentikit: false
      },
    ];
  },
  deleteRobado(state, payload) {
    state.list = [...state.list.slice(0, payload), ...state.list.slice(payload + 1)];
  },
};

export default {
  emptyObject,
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
